const nameToUrls = {
  example: "api/example/",
  perfil: "api/perfil/",
};
export default nameToUrls;
